import { render, staticRenderFns } from "./DeviceDetailTable.vue?vue&type=template&id=4f649e1a&"
import script from "./DeviceDetailTable.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports